import React from 'react';
import '../css/About.css';
import Header from './Header';
import Footer from './Footer';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import img1 from '../images/img1.png';
import Basic from './Basic';
import {FadeTransform,Stagger} from 'react-animation-components';

function CardPage(props){
    return(
        <div>
            <Card style={{ width: '18rem' }} className="card">
            <Card.Body>
                <Card.Title style={{ marginBottom:'30px',fontWeight:'800' }}>{props.title}</Card.Title>
                <Card.Text>
                    {props.desc}
                </Card.Text>
            </Card.Body>
            </Card>
        </div>
    );
}

function CardLayout(props){
    return(
        <div className="card1">
            <img height="100%" width="100%" src={props.img} />
            <span>{props.title}</span>
            <span>{props.degree}</span>
        </div>
    );
}
function AboutPage() {
  return (
    <div>

        <Stagger in>
        <div className="heading">
            <h3>What I do</h3>
        </div>
        <Basic/>
        <FadeTransform
            in
            transformProps={{
                enterTransform: 'translateX(0px)',
                exitTransform: 'translateX(100px)'
            }}
        >
        <div className="container education">
            <div className="row">
                <CardPage title={"Coding Enthusiast"} desc={"I have solved 600+ problems on various platforms Leetcode, Hackerearth"}  />
                <CardPage title={"Data Science and Machine Learning"} marks={88.6} desc={"I have developed deep learning and machine learning models"}/>
                <CardPage title={"Web Development"} desc={"I am currently working on MERN Stack"}/>
            </div>
        </div>
        
        </FadeTransform>
        </Stagger>

    </div>
  )
}


export default AboutPage